module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_LCS_1033_Parents_v3.98d60a75.jpg";